var map = {
	"./extra_setting_groups": "dba6",
	"./extra_setting_groups.json": "dba6",
	"./main": "1405",
	"./main.vue": "1405",
	"./modal": "8115",
	"./modal.vue": "8115",
	"./store": "1ccc",
	"./store.js": "1ccc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "caff";